
<script>
import {
  required,
} from "vuelidate/lib/validators";
import { notify } from '@/helpers/notify' 

export default {
  name: 'GroupModal',
  props:[
    "groupList"
  ],
  data() {
    return {
        form: {},
        submitted: false
        };
    },
    validations: {
        form: {
        name: { required },
        },
    }, 
    methods: {
        handleSubmit() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                if(this.form.id)
                this.update();
                else
                this.create();
            }
            this.submitted = false;
        },
    create(){
       this.$http.post('/technic-service/group/store', this.form)
        .then(resp => {
          this.form = {};
          this.groupList.push(resp.data.content)
          return notify.success(resp.data.message)
        })
        .catch(error => error)
    },
    update(){
      this.$http.put('/technic-service/group/' + this.form.id , this.form)
        .then(resp => {
          this.form = {};
          return notify.success(resp.data.message)
        })
        .catch(error => error)
    },
    remove(id){
      this.$http.delete('/technic-service/group/' + id)
        .then(resp => {
          if(resp.data.code !==  100)  return notify.error(resp.data.message)
            this.groupList.filter(e=> e.id != id)
            return notify.success(resp.data.message)
         })
        .catch(error => error)
    },
    close(){
      this.$parent.$bvModal.hide('mainstok-modal-scoped')
    }
  },
};
</script>

<template>
  <b-modal 
        id="mainstok-modal-scoped"
        title="İş Tanımları"  
        no-close-on-backdrop 
        hide-footer>
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <label class="col-md-4">Grup Adı</label>
          <div class="col-md-8">
              <div class="mb-3">
                  <input
                  id="name"
                  v-model="form.name"
                  type="text"
                  class="form-control"
                  placeholder="Örn; Müşteri Modemi"
                  :class="{
                      'is-invalid': submitted && $v.form.name.$error,
                  }"
                  />
                  <div
                  v-if="submitted && $v.form.name.$error"
                  class="invalid-feedback"
                  >
                  <span v-if="!$v.form.name.required"
                      >Bu alanı doldurmak zorunludur.</span
                  >
                  </div>
              </div>
          </div>
        </div>
        <div class="d-flex justify-content-end mt-3">
        <div>
          <b-button variant="light" @click="close()">Vazgeç</b-button>
          <b-button 
            v-if="form.id"
            type="submit" 
            variant="warning" 
            class="ms-1"
            >Güncelle
          </b-button>
          <b-button 
            v-else
            type="submit" 
            variant="success" 
            class="ms-1"
            >Oluştur
          </b-button>
        </div>
        </div>
      </form>
        <div class="row">
          <label class="col-md-12">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>Tanım</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="list in groupList" :key="list.id">
                        <td>{{ list.name }}</td>
                        <td style="width:50px">
                          <button class="btn btn-danger btn-sm" @click="remove(list.id)">
                            <i class="bx bx-trash-alt"></i>
                          </button>
                        </td>
                    </tr>
                </tbody>
            </table>
          </label>
        </div>
    </b-modal>
</template>